export default __webpack_public_path__ + "static/media/studentView.c690dd66.svg";